import React from 'react';
import { Hero } from '../components/Hero';
import { ProofBar } from '../components/ProofBar';
import { PainSection } from '../components/PainSection';
import { MistrBrain } from '../components/MistrBrain';
import { ChannelCards } from '../components/ChannelCards';
import { AskAnything } from '../components/AskAnything';
import { BuiltDifferent } from '../components/BuiltDifferent';
import { HowItWorks } from '../components/HowItWorks';
import { FeaturesGrid } from '../components/FeaturesGrid';
import { StorySection } from '../components/StorySection';
import { IntegrationsPreview } from '../components/IntegrationsPreview';
import { Pricing } from '../components/Pricing';
import { FinalCTA } from '../components/FinalCTA';
export function HomePage() {
  return <main data-id="element-1688">
      <Hero data-id="element-1689" />
      <ProofBar data-id="element-1690" />
      <PainSection data-id="element-1691" />
      <MistrBrain data-id="element-1692" />
      <ChannelCards data-id="element-1693" />
      <AskAnything data-id="element-1694" />
      <BuiltDifferent data-id="element-1695" />
      <HowItWorks data-id="element-1696" />
      <FeaturesGrid data-id="element-1697" />
      <StorySection data-id="element-1698" />
      <IntegrationsPreview data-id="element-1699" />
      <Pricing data-id="element-1700" />
      <FinalCTA data-id="element-1701" />
    </main>;
}